/*
  Babblee · FAQ filtering
  ===========================================================================
  Search and category filter, applied together. Progressive: with JavaScript
  off every question is on the page and every answer opens, because the cards
  are native <details>. This only narrows what is shown.
*/
(() => {
  const root = document.querySelector('[data-bb-faq]');
  if (!root) return;

  const search = root.querySelector('[data-bb-faq-search]');
  const clear = root.querySelector('[data-bb-faq-clear]');
  const count = root.querySelector('[data-bb-faq-count]');
  const empty = root.querySelector('[data-bb-faq-empty]');
  const items = [...root.querySelectorAll('[data-bb-faq-item]')];
  const chips = [...root.querySelectorAll('[data-bb-faq-cat]')];

  let category = 'all';

  /* Matched on question and answer both. Searching a FAQ for "label" should
     find the returns answer that mentions one, even though no question does. */
  const haystack = (el) => (el.textContent || '').toLowerCase();

  const apply = () => {
    const q = (search?.value || '').trim().toLowerCase();
    let shown = 0;

    for (const el of items) {
      const inCategory = category === 'all' || el.dataset.cat === category;
      const inSearch = !q || haystack(el).includes(q);
      const show = inCategory && inSearch;
      el.hidden = !show;
      if (show) shown += 1;
      /* Opened by a search so the matching words are on screen rather than
         behind another click; closed again when the search is cleared. */
      if (q && show) el.open = true;
      if (!q) el.open = false;
    }

    if (clear) clear.hidden = !q;
    if (empty) empty.hidden = shown > 0;
    if (count) {
      count.textContent = shown === items.length
        ? `${items.length} questions`
        : `${shown} of ${items.length} questions`;
    }
  };

  search?.addEventListener('input', apply);
  clear?.addEventListener('click', () => { if (search) { search.value = ''; search.focus(); } apply(); });
  search?.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && search.value) { e.preventDefault(); search.value = ''; apply(); }
  });

  chips.forEach((chip) => chip.addEventListener('click', () => {
    category = chip.dataset.bbFaqCat || 'all';
    chips.forEach((c) => {
      const on = c === chip;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', String(on));
    });
    apply();
  }));
  chips.forEach((c) => c.setAttribute('aria-pressed', String(c.classList.contains('is-active'))));

  apply();
})();
